
interface ModuleTemplateOptions {
  title: string;
  image: string;
  category: string;
  url?: string;
}

const benefits_economizar = [
  {
    title: "E-commerce",
    image: "/gifs/benefits/ecommerce.gif",
    category: "Economizar",
    url: "ecommerce",
  },
  {
    title: "Lojas Físicas",
    image: "/gifs/benefits/lojas.gif",
    category: "Economizar",
    url: "local",
  },
  {
    title: "Cinema",
    image: "/gifs/benefits/cinema.gif",
    category: "Economizar",
    url: "cinema",
  },
];

const benefits_para_ler = [
  {
    title: "Livros",
    image: "/gifs/benefits/livros.gif",
    category: "Benefícios Para Ler",
  },
  {
    title: "Audio Books",
    image: "/gifs/benefits/audiobooks.gif",
    category: "Benefícios Para Ler",
  },
  {
    title: "Revista",
    image: "/gifs/benefits/revista.gif",
    category: "Benefícios Para Ler",
  },
];

const benefits_beneficios = [
  {
    title: "Telemedicina",
    image: "/gifs/benefits/telemedicina.gif",
    category: "Benefícios",
  },
  {
    title: "Music",
    image: "/gifs/benefits/music.png",
    category: "Benefícios",
  },
  {
    title: "Ligga Play",
    image: "/gifs/benefits/liggaplay.gif",
    category: "Benefícios",
  },
  {
    title: "Cashback",
    image: "/gifs/benefits/cashback.gif",
    category: "Benefícios",
  },
  {
    title: "Seguros",
    image: "/gifs/benefits/seguros.gif",
    category: "Benefícios",
  },
  {
    title: "Points",
    image: "/gifs/benefits/points.png",
    category: "Benefícios",
  },
];

export const allTemplates: ModuleTemplateOptions[] = [
  ...benefits_economizar,
  ...benefits_para_ler,
  ...benefits_beneficios,
];
